import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material";
import { ExcelService, Combo2Service, ComboService } from "../../../../services/index";
import { SalesOrderService } from "../../../../services/salesOrder.service";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { template } from "lodash";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import { id } from "@swimlane/ngx-datatable/release/utils";

@Component({
  selector: "partyWiseCounterEst",
  templateUrl: "partyWiseCounterEst.html",
})
export class partyWiseCounterEst implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  IsWait: boolean = false;
  Iselected_party: boolean = false;
  party_view: boolean = false;

  exceldata: any;
  attachment: any;
  curDate = new Date();

  filter = {
    party_id: "",
    party_name: "",
    counter_from: "",
    counter_to: "",
    groupby: "party"
  };
  columns = [];
  excelColumns = [];
  toggleCol = [];
  newDesignList = [];
  partyList = [];

  pendingOrderStock: any;
  totpartyOrder: any;
  shirtStock = [];
  partyData = [];
  counterCustomer = [];
  style_name: any;
  variety_name: any;
  tab_index: boolean = false;

  constructor(
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule,
    public toasterService: ToasterService,
    private excelService: ExcelService,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public comboservice: ComboService

  ) {

    this.filter.counter_from = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.counter_to = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.getPartyList();
    this.getColumns();
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

  }
  counterprint(data) {
    data.page_type = 'party_wise';
    this.salesOrderServ.counterprint(data).then(function (res: any) { })
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  dcAuto() {


    this.salesOrderServ.GetCountdcAuto({}).then((res: any) => {
    });

  }

  SavePartyWiseCounter() {

    let params: any = Object.assign({}, this.filter);
    params["shirt_data"] = JSON.stringify(this.shirtStock);
    params["ord_data"] = JSON.stringify(this.counterCustomer);
    params["style"] = this.style_name;
    params["variety"] = this.variety_name;
    this.counterprint(params);
    // let that = this;
    // swal({
    //   title: "Are you sure to save this Details?",
    //   type: "warning",
    //   showCancelButton: true,
    //   confirmButtonText: "Yes, save it!",
    //   cancelButtonText: "No, want to change",
    // }).then(function () {

    //   that.salesOrderServ
    //     .SavePartyWiseCounter(params)
    //     .then(function (res: any) {
    //       that.counterprint(params);
    //       if (res.success) {
    //         that.toasterService.pop({
    //           bodyOutputType: 1,
    //           type: "success",
    //           title: "SUCCESS",
    //           body: res.message,
    //         });

    //       } else {
    //         swal("ERROR", res.message, "error");
    //       }
    //     })
    //     .catch(function (error: any) {
    //       let res = JSON.parse(error._body);
    //       swal("ERROR", res.message, "error");
    //     });
    // });
  }
  onGoToNextFld1($event, fld, ind) {
    if (fld == 'rf36')
      ind = ind + 1;
    setTimeout(() => {
      $("#" + fld + "-" + ind).focus()
    }, 100);
  }
  GetPartyview() {
    this.party_view = true;
  }
  SelectParty() {
    this.getPartyWiseCounter();

  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  tabstyle(boolean) {
    this.tab_index = boolean;
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });

  }
  getViewdesigndet(ind) {
    if (this.filter.groupby == 'party') {
      this.filter.party_id = this.counterCustomer[ind].party_id;
      this.filter.groupby = 'design'
    }
    else {
      this.filter.party_id = ''
      this.filter.groupby = 'party'
    }

    this.getPartyWiseCounter();
  }
  getPartyWiseCounter() {
    this.IsWait = true;
    this.filter.counter_from = this.datePipe.transform(
      this.filter.counter_from,
      "yyyy-MM-dd"
    );
    // this.filter.counter_to = this.datePipe.transform(
    //   this.filter.counter_to,
    //   "yyyy-MM-dd"
    // );
    let params: any = Object.assign({}, this.filter);

    let that = this;

    that.gridOptions = {
      loading: true,
      columns: [],
    };
    that.salesOrderServ.getPartyWiseCounter(params).then((res: any) => {

      that.IsWait = false;
      that.counterCustomer = [];
      that.counterCustomer = res.counterCustomer;
    });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  ngOnDestroy() {
    this.salesOrderServ;
  }
  clearbtn() {
    this.filter.counter_from = "";
    this.filter.counter_to = "";
    this.filter.party_id = "";
    this.filter.party_name = "";

  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/designSoReport/partyWiseCounterEst.ts